import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { InventoryTypeKey } from '~/constants/inventoryType';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import StaticContext from '~/context/vdp/StaticContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useViewDetailsButton() {
  const {
    spinnerReady: { isLoaded },
    openHotspot,
    setShouldFetchSpinner,
    shouldHideSpinner
  } = useContext(SpinnerContext);
  const { isLite } = useContext(StaticContext);
  const { inventoryType } = useGetVehicleDetails();
  const isWIP = inventoryType === InventoryTypeKey.WIP;

  const [hasFetchedSpinner, setHasFetchedSpinner] = useState(false);
  const [clickedViewDetails, setClickedViewDetails] = useState(false);

  const shouldShow = useMemo(() => {
    if (shouldHideSpinner || isWIP) return false;
    if (isLite) {
      return !hasFetchedSpinner || (hasFetchedSpinner && isLoaded);
    }

    return isLoaded;
  }, [shouldHideSpinner, isWIP, isLite, hasFetchedSpinner, isLoaded]);

  // On lite we need to fetch the spinner before opening the hotspot
  const handleClick = useCallback(() => {
    if (isLite && !isLoaded && !hasFetchedSpinner && !clickedViewDetails) {
      setShouldFetchSpinner(true);
      setHasFetchedSpinner(true);
      setClickedViewDetails(true);
    } else {
      openHotspot(0, false);
    }
  }, [
    clickedViewDetails,
    isLite,
    isLoaded,
    hasFetchedSpinner,
    setShouldFetchSpinner,
    openHotspot
  ]);

  // On lite we need to open the hotspot after spinner has fetched and loaded
  useEffect(() => {
    if (isLite && isLoaded && clickedViewDetails) {
      openHotspot(0, false);
    }
  }, [clickedViewDetails, isLite, isLoaded, openHotspot]);

  return { shouldShow, handleClick };
}
